import PropTypes from "prop-types";
import Icon from "../Icon/Icon";
import getFileIconByContentType from "../../utils/FileThumbnail/getFileIconByContentType";
import { jsx as _jsx } from "react/jsx-runtime";
const FileThumbnail = _ref => {
  let {
    id = "",
    className = "",
    color = "",
    contentType = "",
    onThumbnailClick = null,
    size = 60,
    style = {}
  } = _ref;
  const icon = getFileIconByContentType(contentType);
  return /*#__PURE__*/_jsx("div", {
    className: className,
    children: onThumbnailClick ? /*#__PURE__*/_jsx("a", {
      id: id,
      onClick: onThumbnailClick,
      role: "button",
      tabIndex: 0,
      children: /*#__PURE__*/_jsx(Icon, {
        color: color,
        icon: icon,
        size: size,
        style: style
      })
    }) : /*#__PURE__*/_jsx(Icon, {
      color: color,
      icon: icon,
      size: size,
      style: style
    })
  });
};
FileThumbnail.propTypes = {
  /** id for reference */
  id: PropTypes.string,
  /** className for reference */
  className: PropTypes.string,
  /** Color of icon */
  color: PropTypes.string,
  /** Type of file (i.e.: `'image/png'`) */
  contentType: PropTypes.string.isRequired,
  /** clickable functionality. */
  onThumbnailClick: PropTypes.func,
  /** Size of FileThumbnail Icon */
  size: PropTypes.number,
  /** Override the inline-styles of the FileThumbnail Icon || **Not Recommended** */
  style: PropTypes.object
};
export default FileThumbnail;
//# sourceMappingURL=FileThumbnail.js.map